module.exports = __webpack_public_path__ + "static/media/Eyes_grey.3abf1504.svg";